import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=bb880714&scoped=true&"
import script from "./AccountCard.vue?vue&type=script&lang=js&"
export * from "./AccountCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=bb880714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb880714",
  null
  
)

export default component.exports